/*
 * @Author: yeertesi
 * @Date: 2023-11-07 11:15:17
 * @LastEditTime: 2023-12-08 12:24:27
 * @LastEditors: yeertesi
 * @Description: 公共 entry-client
 * @FilePath: /nami-activity/client/lib/entry-client.tsx
 */
import React from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

declare global {
  interface Window {
    __isSSR__: boolean
    owl: any
  }
}

/**
 * @description: 客户端渲染入口函数
 * @param {function} App 必选、渲染的根组件
 * @param {Function} ErrorCallback 可选、客户端异常情况下执行的回调函数
 * @return {*}
 */
export const clientEntry = (App: () => JSX.Element): void => {
  if (window.__isSSR__) {
    hydrateRoot(
      document.getElementById('app') as HTMLElement,
      <BrowserRouter>
        <App />
      </BrowserRouter>

    )
  } else {
    const rootDom = document.getElementById('app')
    const root = createRoot(rootDom)
    // 暂时使用空的，因为还没引入服务端获取的状态
    root.render(
      <BrowserRouter>
        <App />
      </BrowserRouter>
    )
  }
}
